export enum PaymentMethodTypeEnum {
  BankAccount = 'bank_account',
  Card = 'card',
  Invoice = 'invoice',
}

export interface IPaymentMethod {
  readonly _id: string;
  readonly id: string;
  readonly account_holder_name: string;
  readonly account_holder_type: string;
  readonly bank_name: string;
  readonly routing_number: string;
  readonly status: string;
  readonly address_city: string;
  readonly address_country: string;
  readonly address_line1: string;
  readonly address_line1_check: string;
  readonly address_line2: string;
  readonly address_state: string;
  readonly address_zip: string;
  readonly address_zip_check: string;
  readonly brand: string;
  readonly cvc_check: string;
  readonly exp_month: number;
  readonly expiry_month: number;
  readonly exp_year: number;
  readonly expiry_year: number;
  readonly funding: string;
  readonly fingerprint: string;
  readonly last4: string;
  readonly country: string;
  readonly currency: string;
  readonly instant_payout_available: boolean;

  // is_expired is not updated as it should be, use isExpired from reducer instead
  readonly is_expired: boolean;
  readonly stripe_id: string;
  readonly is_selected: boolean;
  readonly type: PaymentMethodTypeEnum;
}
